
export const WAREHOUSE_LIST_REQUEST = 'WAREHOUSE_LIST_REQUEST';
export const WAREHOUSE_LIST_SUCCESS = 'WAREHOUSE_LIST_SUCCESS';
export const WAREHOUSE_LIST_FAIL = 'WAREHOUSE_LIST_FAIL';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAIL = 'PRODUCT_LIST_FAIL';
export const PRODUCT_LIST_RESET = 'PRODUCT_LIST_RESET';

export const BATCH_LIST_REQUEST = 'BATCH_LIST_REQUEST';
export const BATCH_LIST_SUCCESS = 'BATCH_LIST_SUCCESS';
export const BATCH_LIST_FAIL = 'BATCH_LIST_FAIL';
export const BATCH_LIST_RESET = 'BATCH_LIST_RESET';